import type { XmlItemRating } from "../../../../shared/analysis-types";

export interface ResolvedScorecardItem {
  id: string;
  rating: Exclude<XmlItemRating, "na">;
  label: string;
  summary: string;
  evidence?: string;
  what_to_try?: string;
  why_it_matters?: string;
  copy_paste_reinforcement?: string;
}

export function filterVisibleScorecardItems(items: ResolvedScorecardItem[], showMeets: boolean) {
  if (showMeets) return items;
  return items.filter((item) => item.rating !== "meets");
}
